import React from 'react'
import { Grid, PageSection } from '@superhi/design'

import LibraryPostArticleCard from '../../../../../../components/LibraryPostArticleCard'
import LibraryPostVideoCard from '../../../../../../components/LibraryPostVideoCard'

type LibraryPost =
  | React.ComponentProps<typeof LibraryPostVideoCard>
  | React.ComponentProps<typeof LibraryPostArticleCard>

type Props = {
  title: string
  backgroundColor: 'blue' | 'yellow'
  posts: LibraryPost[]
}

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 3,
  medium: 3,
  large: 4,
}

const GRID_1_SLIDER = { small: true, medium: true }

const RelatedPosts: React.FC<Props> = ({ title, backgroundColor, posts = [] }) => (
  <PageSection
    data-component-name="RelatedPosts"
    title={title}
    align="left"
    headingLevel={2}
    backgroundColor={backgroundColor === 'blue' ? 'pale-blue' : 'yellow'}
  >
    <Grid slider={GRID_1_SLIDER}>
      {posts.map((post): React.ReactElement => {
        switch (post.__typename) {
          case 'LibraryPostArticle': {
            return (
              <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                <LibraryPostArticleCard {...post} headingLevel="3" noDescription imageLazy />
              </Grid.Cell>
            )
          }
          case 'LibraryPostVideo': {
            return (
              <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                <LibraryPostVideoCard {...post} headingLevel="3" noDescription imageLazy />
              </Grid.Cell>
            )
          }
        }
      })}
    </Grid>
  </PageSection>
)

export default RelatedPosts
